import { memoize } from '@epicuro-next/utilities';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import { PRODUCT_ENTITIES_STATE_KEY } from './constants';
import { adapter, ProductEntitiesState } from './product-entities.adapter';

export const selectProductEntitiesState =
  createFeatureSelector<ProductEntitiesState>(PRODUCT_ENTITIES_STATE_KEY);

export const { selectEntities: selectProductEntities } = adapter.getSelectors(
  selectProductEntitiesState,
);

export const selectProduct = memoize((id: string) =>
  createSelector(
    selectProductEntitiesState,
    (state: ProductEntitiesState) => state.entities[id],
  ),
);
